import React from "react";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Label,
    FormGroup,
    Input,
    Table,
    Row,
    Col,
  } from "reactstrap";
  import AddMenu from "./AddMenu.js";
import AddSubmenu from "./AddSubmenu.js";
import AddSubsubmenu from "./AddSubsubmenu.js";
import { useHistory } from "react-router-dom";
const CreateMenu = () =>{
    const navigate = useHistory();
    const [value2, setValue2] = React.useState("div3");
    return(
        <>
        <div className="content pd-0">
          <Row>
            <Card className="mb-0">

              <CardBody style={{minHeight:"522px"}}>
                <Row>
              <Col sm="12">
                    <h4 className="add-content" onClick={() => 
                           // navigate.push("/admin/user/menulist")
                           navigate.goBack()
                        }style={{"width":"185px"}}>
                        <Button className="btn btn-icon btn-link-add btn-sm mr-2">
                          <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        </Button>
                      Create Menu
                    </h4>
              </Col>
              </Row>
              <hr></hr>
              <Row>
              <Col sm="12" lg="12" className="mb-4">
               
                <FormGroup check className="form-check-radio" inline>
                  <Label check>
                    <Input
                      id="exampleRadios3"
                      name="exampleRadio"
                      type="radio"
                      value="div1"
                      checked={value2 === "div1"}
                      onChange={(e) => setValue2(e.currentTarget.value)}
                    />
                    <span className="form-check-sign" />
                    Single layer Menu
                  </Label>
                </FormGroup>
                <FormGroup check className="form-check-radio" inline>
                  <Label check>
                    <Input
                      id="exampleRadios4"
                      name="exampleRadio"
                      type="radio"
                      value="div2"
                      checked={value2 === "div2"}
                      onChange={(e) => setValue2(e.currentTarget.value)}
                    />
                    <span className="form-check-sign" />
                    Two layer Menu
                  </Label>
                </FormGroup>
                <FormGroup check className="form-check-radio" inline>
                  <Label check>
                    <Input
                      id="exampleRadios5"
                      name="exampleRadio"
                      type="radio"
                      value="div3"
                      checked={value2 === "div3"}
                      onChange={(e) => setValue2(e.currentTarget.value)}
                    />
                    <span className="form-check-sign" />
                    Three layer Menu
                  </Label>
                </FormGroup>
              </Col>
              {value2 === "div1" && (
                <Col lg="12">
                  <Col className="div1">
                    <AddMenu 
                    //btnSub={(val) => setModalClassic(val)} 
                    />
                  </Col>
                </Col>
              )}
              {value2 === "div2" && (
                <Col lg="12">
                  <Col className="div2">
                    <AddSubmenu 
                   // btnSub={(val) => setModalClassic(val)} 
                    />
                  </Col>
                </Col>
              )}
              {value2 === "div3" && (
                <Col lg="12">
                  <Col className="div3" style={{minHeight:"380px"}}>
                    <AddSubsubmenu 
                   // btnSub={(val) => setModalClassic(val)} 
                    />
                  </Col>
                </Col>
              )}
            </Row>
              </CardBody>
            </Card>
          </Row>
        </div>
      </>
    );
}

export default CreateMenu;